import React from 'react'
import classNames from 'classnames'
import styles from './Title.module.scss'

const PREFIX = 'font-'

const Title = ({
  children = null,
  type,
  color = 'primaryColor',
  fontSize = 'medium',
  onClick = null,
  className = '',
  bold = false,
  alignCenter = false,
}) => {
  const myClassName = classNames(
    styles.title,
    styles[color],
    styles[`${PREFIX}${fontSize}`],
    onClick && styles.click,
    { [styles.bold]: bold, [styles.textCenter]: alignCenter },
    className
  )

  return React.createElement(
    type,
    { className: myClassName, onClick: onClick || (() => {}) },
    children
  )
}

export const fontSizes = Object.keys(styles)
  .filter(className => className.lastIndexOf(PREFIX, 0) === 0)
  .map(fontSize => fontSize.substring(PREFIX.length))

export default React.memo(Title)
